module.exports = __webpack_public_path__ + "img/Cluster Icon.0bfebd7a.png";